import React, { useState } from 'react';
import genStyles from './generale.module.css';
import ReactDOM from 'react-dom';
import { DropdownSelect } from './dropdownSelect';
import DrawService from '../service/DrawService';
import ShowService from '../service/showService';

export default function SetStyleForm({ onClose, objectCur, setEntites, popoverStyle, selectedRows, entitesFile}) {
    
    const [form, setForm] = useState({
        polycontourColor : '',
        polycontourOpacity: '',
        polycontourEpaisseur : '',
        polyColor:'',
        polyOpacity:''
    });

    const isDisabled = Object.values(form).every(value => value === '' || value === 0 || value === null);

    const presetColors = [
        { name: "#36c980", iconClass: "#36c980" },
        { name: "#a0d44f", iconClass: "#a0d44f" },
        { name: "#c9b957", iconClass: "#c9b957" },
        { name: "#face47", iconClass: "#face47" },
        { name: "#7945ca", iconClass: "#7945ca" },
        { name: "#a15bd5", iconClass: "#a15bd5" },
        { name: "#6499f4", iconClass: "#6499f4" },
        { name: "#76cbf9", iconClass: "#76cbf9" },
        { name: "#b63453", iconClass: "#b63453" },
        { name: "#db465e", iconClass: "#db465e" },
        { name: "#f61e87", iconClass: "#f61e87" },
        { name: "#f75cbf", iconClass: "#f75cbf" },
        { name: "#f7683c", iconClass: "#f7683c" },
        { name: "#f7af54", iconClass: "#f7af54" },
        { name: "#7d5247", iconClass: "#7d5247" },
        { name: "#818181", iconClass: "#818181" },
        { name: "#252525", iconClass: "#252525" },
        { name: "#FFFFFF", iconClass: "#FFFFFF" },
    ];


    const saveStyle = () => {
        objectCur.forEach((entity) => {
            setEntites((prevList) => {
                return prevList.map((entityup) => {
                    if (entityup.id !== entity.id) return entityup;
    
                    const oldGeo = entity.geojson;
    
                    // On recrée chaque niveau pour éviter read-only
                    let newOptions = { ...oldGeo.properties.options };
                    let newCss = oldGeo.properties.css
                        ? { ...oldGeo.properties.css }
                        : undefined;
    
                    if (entityup.type === "marker") {
                        if (form.polyColor) {
                            newOptions = {
                                ...newOptions,
                                icon: {
                                    ...newOptions.icon,
                                    options: {
                                        ...newOptions.icon.options,
                                        markerColor: form.polyColor
                                    }
                                }
                            };
                        }
                    }
        
                    else if (entityup.type === 'polyline') {
                        if (form.polycontourColor) {
                            newOptions.color = form.polycontourColor;
                        }
                        if (form.polycontourOpacity) {
                            newOptions.opacity = form.polycontourOpacity;
                        }
                        if (form.polycontourEpaisseur && form.polycontourEpaisseur != 0) {
                            newOptions.weight = form.polycontourEpaisseur;
                        }
                    }
    
                    else if (
                        entityup.type === 'polygon' ||
                        entityup.type === 'circle' ||
                        entityup.type === 'rectangle'
                    ) {
                        if (form.polycontourColor) newOptions.color = form.polycontourColor;
                        if (form.polycontourOpacity) newOptions.opacity = form.polycontourOpacity;
                        if (form.polycontourEpaisseur && form.polycontourEpaisseur != 0)
                            newOptions.weight = form.polycontourEpaisseur;
    
                        if (form.polyColor) newOptions.fillColor = form.polyColor;
                        if (form.polyOpacity) newOptions.fillOpacity = form.polyOpacity;
                    }
    
                    const newGeo = {
                        ...oldGeo,
                        properties: {
                            ...oldGeo.properties,
                            options: newOptions,
                            ...(newCss ? { css: newCss } : {})
                        }
                    };
    
                    return {
                        ...entity,
                        geojson: newGeo
                    };
                });
            });
        });
    
        onClose();
    };
    

    const updateField = (key, value) => {
        setForm((prev) => {
            let updatedValue = value;

            // Si on modifie la transparence, convertir % en valeur 0-1
            if (key === "polycontourOpacity" || key === "polyOpacity") {
                const numericValue = parseFloat(value);
                if (!isNaN(numericValue)) {
                    updatedValue = numericValue / 100;
                } else {
                    updatedValue = 0;
                }
            }

            const updatedForm = { ...prev, [key]: updatedValue };
           
            objectCur.forEach((entity) => {
                DrawService.updateStyleLayer(updatedForm, entity.id,entity.type);
            });
            return updatedForm;
        });
    };

    const closeWithoutSave = () => {
        entitesFile.forEach((item) => {
            const geojson = item.geojson;
            ShowService.addEntitesToMap(geojson,'show');

            if (selectedRows.includes(item.id)) {
                DrawService.highlightEntityCollection(item);
            }
        });
        onClose();
    }

    const popover = (
        <div
            style={{
                position: "absolute",
                top: popoverStyle.top,
                left: popoverStyle.left,
                zIndex: 2000,
                backgroundColor: "white",
                border: "1px solid #ccc",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                padding: "10px",
                width: "450px"
            }}
        >
            <button
                onClick={closeWithoutSave}
                style={{
                    position: "absolute",
                    top: "10px",
                    right: "15px",
                    background: "transparent",
                    border: "none",
                    fontSize: "18px",
                    cursor: "pointer",
                    color: "#666",
                }}
                title="Fermer"
                >
                <i className="fa-solid fa-xmark"></i>
            </button> 
            <div className={genStyles.edsection} style={{marginBottom:'0px !important'}}>
                <div className={genStyles.titleedsection}>
                    <i className={`fa-solid fa-palette ${genStyles.fontSize18} ${genStyles.fontSize18} ${genStyles.icomargin}`}></i>
                    <span className={`${genStyles.fontSize16} ${genStyles.bold} ${genStyles.bgcolorfirsttext}`}>
                    Styles
                    </span>
                </div>
                <div className="row container_style mb10">
                    <div className="col s4">
                        <span className={`${genStyles.fontSize15}  ${genStyles.bgcolorfirsttext}  ${genStyles.noMargin}`}>Contour</span>
                        <div className={genStyles.pickctn}>
                            <DropdownSelect
                                options={presetColors}
                                selected={form.polycontourColor}
                                onChange={(color) => updateField("polycontourColor", color)}
                                type="color"
                                showCustomColor={true}
                            />                               
                            <input
                                className={genStyles.inputtCol}
                                type="text"
                                value={form.polycontourColor}
                                onChange={(e) => updateField("polycontourColor", e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="col s4">
                        <span className={`${genStyles.fontSize15}  ${genStyles.bgcolorfirsttext}  ${genStyles.noMargin}`}>Opacité</span>
                            <div className={genStyles.pickctn}>
                            <input
                                className={genStyles.inputtCol}
                                type="number"
                                min="0"
                                max="100"
                                value={form.polycontourOpacity !== '' ? (form.polycontourOpacity * 100).toFixed(0) : ''}
                                onChange={(e) => updateField("polycontourOpacity", e.target.value)}
                            />
                            <span> %</span>
                            </div>
                    </div>
                    <div className="col s4">
                        <span className={`${genStyles.fontSize15}  ${genStyles.bgcolorfirsttext}  ${genStyles.noMargin}`}>Épaisseur</span>
                        <input
                            className={genStyles.inputtCol}
                            type="number"
                            min="0"
                            value={form.polycontourEpaisseur}
                            onChange={(e) => updateField("polycontourEpaisseur", e.target.value)}
                        />
                    </div>
                </div>   
                <div className="row container_style mb10">
                    <div className="col s4">
                        <span className={`${genStyles.fontSize15}  ${genStyles.bgcolorfirsttext}  ${genStyles.noMargin}`}>Remplissage</span>
                        <div className={genStyles.pickctn}>
                            <DropdownSelect
                                options={presetColors}
                                selected={form.polyColor}
                                onChange={(color) => updateField("polyColor", color)}
                                type="color"
                                showCustomColor={true}
                            />                               
                            <input
                                className={genStyles.inputtCol}
                                type="text"
                                value={form.polyColor}
                                onChange={(e) => updateField("polyColor", e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="col s4">
                        <span className={`${genStyles.fontSize15}  ${genStyles.bgcolorfirsttext}  ${genStyles.noMargin}`}>Opacité</span>
                        <div className={genStyles.pickctn}>
                            <input
                                className={genStyles.inputtCol}
                                type="number"
                                min="0"
                                max="100"
                                value={form.polyOpacity !== '' ? (form.polyOpacity * 100).toFixed(0) : ''}
                                onChange={(e) => updateField("polyOpacity", e.target.value)}
                            />
                            <span> %</span>
                        </div>
                    </div>
                    <div className={`${genStyles.pickctn} col s4`} >
                        <button
                            className={`btn full_width uppercase ${genStyles.bgcolorfirst}`}
                            onClick={saveStyle}
                            disabled={isDisabled}
                            style={{
                                opacity: isDisabled ? 0.5 : 1,
                                cursor: isDisabled ? "not-allowed" : "pointer",
                                transition: "opacity 0.2s ease"
                            }}
                        >
                        Enregistrer
                        </button>
                    </div>
                </div>                  
            </div>

        </div>
    );

    return ReactDOM.createPortal(popover, document.body);
}
